import React from 'react'

const Errors = () => {
  return (
    <div>
      <h1>Sorry! The page Error 404</h1>
    </div>
  )
}

export default Errors
